import React, { useEffect } from 'react';
import CtaButton from '../../../shared/components/ctaButton/cta';
import { AosAnimation } from '../../../shared/components/fader/fader';

const Home = ({ content }) => {
  // Scroll to top at page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [content]);

  return (<div className='home'>

    {/* home banner video section start */ }
    <div className="homebanner">
      <div className="bg-box" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/homepage_bg.svg)`}}/>
      <div className="container ">
        <div className={ `row-wrap` }>
          <div className="box-12">
            <div className="content-box" >
              <div className="intro-box"  >
                <h1 className='heading has-line'>{ content ? content.banner_title : 'Simplify your banking experience with Demivolt' }</h1>
                <div dangerouslySetInnerHTML={ { __html: content && content.banner_content } }></div>
                {
                  content ? content.banner_cta_button && <div className="button-box" >
                    <CtaButton
                      className='button-solid'
                      to={ content.banner_cta_button.url }
                      target={ content.banner_cta_button.target }
                    >{ content.banner_cta_button.title }</CtaButton>
                  </div> : <div className="button-box" >
                      <CtaButton className='button-solid' >Open an account</CtaButton>
                    </div>
                }

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* home banner video section end */ }



    {/* proposition section start */ }
    <div className="proposition-box">
      <div className="container">
        <AosAnimation animationType="fade-up">
          <div className="row-wrap propositionList">
            <span className='line'></span>
            {
              content && content.features.map((obj) => {
                return <div className="box-12 item-box" key={ obj.title }>
                  <div className="inner-box">
                    <div className="icon-box">
                      <figure>

                        {
                          obj.icon &&
                          <img src={ (obj.icon && obj.icon.url) || `${process.env.PUBLIC_URL}/images/proposition/icon_shield_obj@2x.png` } alt="icon-shield" />
                        }
                        {
                          obj.hover_icon &&
                          <img className='hoverImage' src={ (obj.hover_icon && obj.hover_icon.url) || `${process.env.PUBLIC_URL}/images/proposition/icon_shield_obj_white@2x.png` } alt="hover-shield" />
                        }
                      </figure>
                    </div>
                    <div className="content-box">
                      <h2>{ obj.title }</h2>
                      <div dangerouslySetInnerHTML={ { __html: obj.info } }>
                      </div>
                    </div>
                  </div>
                </div>;
              })
            }


          </div>


        </AosAnimation>
      </div>
    </div>
    {/* proposition section end */ }

  </div >);
};

export default Home;